// dialogo-mensaje.module.js
"use strict";

import angular from "angular";
import { DIALOGO_MENSAJE_COMPONENT } from "./dialogo-mensaje.component";
import "@telecor-web/inetum-autofocus";

const DIALOGO_MENSAJE_MODULE = angular
    .module("dialogoMensaje", ["inetumAutofocus"])
    .component("dialogoMensaje", DIALOGO_MENSAJE_COMPONENT)
    .name
;

export { DIALOGO_MENSAJE_MODULE };
